import password from './password'
import phone from './phone'
import is_not_extend from './is_not_extend'
import is_not_zero from './is_not_zero'
import yyyymmdd from './yyyymmdd'
import max_length from './max_length'
import min_length from './min_length'
import registration_number from './registration_number'
import company_number from './company_number'
import min_text_length from './min_text_length'
import required_check_empty from './required_check_empty'

const defineCustomRule = () => {
  password()
  phone()
  is_not_extend()
  is_not_zero()
  yyyymmdd()
  max_length()
  min_length()
  registration_number()
  company_number()
  min_text_length()
  required_check_empty()
}

export default defineCustomRule
